import { createSelector } from 'reselect';

const pioSelect = (state) => state.profile.participationInOrganizations;

export const selectPIO = createSelector(pioSelect, (data) => data);
